<div class="container">
    <div class="row">
        <div class="col mt-2">
            <h4>{{ getTitle() }}</h4>
        </div>
    </div>
    <div class="d-flex flex-row sub-title-text mt-2 mb-2">
        <b class="me-2">PERMS:</b> {{getPermsLabel()}}
    </div>
    <div class="d-flex flex-row sub-title-text mt-2 mb-2">
        <b class="me-2">Item Sub Types:</b> {{ request.ItemSubType | itemSubtype }}
    </div>
    <div class="d-flex flex-row mt-2 mb-2">
        <div class="me-2 sub-title-text start-date">{{ request.StartDate | date: 'MM/dd/yyyy' }}</div>
        <i class="fas fa-arrows-alt-h center-icon sub-title-text" aria-hidden="true"></i>
        <div class="ms-2 sub-title-text end-date">{{ request.EndDate | date: 'MM/dd/yyyy' }}</div>
    </div>
    <div>
        <table class="print-table table outer-table">
            <thead>
                <tr>
                    <th class="fit no-wrap">Last Name</th>
                    <th class="fit no-wrap">First Name</th>
                    <th class="no-wrap">Total Hours</th>
                </tr>
            </thead>
            <tbody *ngFor="let entry of reportContent">
                <tr>   
                    <td>{{entry.LastName}}</td>
                    <td>{{entry.FirstName}}</td>
                    <td>{{entry.Hours}}</td>
                </tr>
                <tr *ngIf="request.ShowDetails && entry.ItemDetailsEntries && entry.ItemDetailsEntries.length > 0">
                    <td colspan="3">
                        <table class="print-table table inner-table">
                            <thead>
                                <tr>
                                    <th>Item Name</th>
                                    <th class="fit no-wrap">Item Type</th>
                                    <th class="fit no-wrap">Hours</th>
                                    <th class="fit no-wrap"></th>
                                    <th class="fit no-wrap">PERMS</th>
                                    <th *ngIf="request.Type === A48ReportTypes.PARAEDUCATOR" class="fit no-wrap">CEC Performance Standard</th>
                                    <th class="fit no-wrap">Completion Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let subEntry of entry.ItemDetailsEntries">   
                                    <td class="word-wrap">{{subEntry.ItemTitle}}</td>
                                    <td class="fit">{{subEntry.Type}}</td>
                                    <td class="fit no-wrap">
                                        {{subEntry.TotalHours}}
                                        <span *ngIf="subEntry.IsCredits" class="badge bg-info">{{subEntry.HoursOrCredits}} C</span>
                                    </td>
                                    <td class="fit no-wrap">{{subEntry.ContextCode === A48SubmissionContextCode.EMERGENCY_CERT_SUBMISSION ? 'E' : '' }}</td>
                                    <td class="fit no-wrap"><i *ngIf="subEntry.Status === A48UserStatus.SUCCESS" class="far fa-clock" aria-hidden="true"></i></td>
                                    <td *ngIf="request.Type === A48ReportTypes.PARAEDUCATOR" class="fit no-wrap">{{act48ReportHelpersService.getCecPerformanceStandard(subEntry.CECPerformance)}}</td>
                                    <td class="fit">{{DateHelpers.validDate(subEntry.CompletionDate) | date: 'MM/dd/yyyy' | emptyString}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

